import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(content)/homepage/components/mainHome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/wrappers/navWrapper.tsx");
